import Pusher from 'pusher-js';

// Enable Pusher logging for debugging
Pusher.logToConsole = true;

// Create Pusher client with cloud config
const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
  cluster: process.env.REACT_APP_PUSHER_CLUSTER,
  forceTLS: true,
});

// Subscribe to the calls channel
const channel = pusher.subscribe('calls');

// Debug logging for connection states
pusher.connection.bind('connecting', () => {
  console.log('🔄 Connecting to Pusher...');
});

pusher.connection.bind('connected', () => {
  console.log('✅ Connected to Pusher');
});

pusher.connection.bind('unavailable', () => {
  console.log('❌ Pusher connection unavailable');
});

pusher.connection.bind('failed', () => {
  console.log('❌ Pusher connection failed');
});

pusher.connection.bind('disconnected', () => {
  console.log('🔌 Disconnected from Pusher');
});

// Channel event logging
channel.bind('pusher:subscription_succeeded', () => {
  console.log('✅ Successfully subscribed to calls channel');
});

channel.bind('pusher:subscription_error', (error) => {
  console.error('❌ Channel subscription error:', error);
});

// Call event handler with detailed logging
channel.bind('call-event', (data) => {
  console.log('📞 Received call event:', data);
});

export { pusher, channel };